import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { apiGet, isBackendConfigured } from '../utils/backendApi';
import { openBugReport } from '../components/BugReportDialog';

// /bugs — the reporter's own bug reports with where each one is on the way
// to production (GET /bugs/mine). The super admin's queue is /admin/bugs.
export const BUG_STATUS = {
  new: ['Received', 'info'],
  fixing: ['Fix in progress', 'info'],
  pr: ['Fix proposed', 'info'],
  uat: ['Testing on UAT', 'warn'],
  shipped: ['Fixed — live', 'ok'],
  closed: ['Closed', ''],
};

export function BugStatusChip({ status }) {
  const [label, tone] = BUG_STATUS[status] || [status || 'Received', ''];
  return <span className={`mf-chip${tone ? ` is-${tone}` : ''}`}>{label}</span>;
}

function when(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString();
}

export default function MyBugs() {
  const { user } = useAuth();
  const member = !!user && !user.isAnonymous;
  const [bugs, setBugs] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!member) return undefined;
    if (!isBackendConfigured()) { setError('The API is not configured.'); return undefined; }
    let stop = false;
    const pull = () => apiGet('/bugs/mine').then((d) => { if (!stop) setBugs(d.bugs || []); }).catch((err) => { if (!stop) setError(err.message); });
    pull();
    const onFiled = () => setTimeout(pull, 1500);
    window.addEventListener('nv:bug-filed', onFiled);
    return () => { stop = true; window.removeEventListener('nv:bug-filed', onFiled); };
  }, [member]);

  return (
    <div className="cs-store" data-nova-note="Your bug reports: everything you filed, with status and the fix release when one shipped.">
      <header className="cs-store-hero">
        <h1>Your bug reports</h1>
        <p>Each report goes to the nventr team. You get an email when the fix is live.</p>
      </header>
      <section className="cs-store-section cs-support-desk">
        <div className="cs-sw-card">
          <div className="bug-list-head">
            <h3>Reports</h3>
            <button type="button" className="cs-btn cs-btn-primary cs-btn-sm" onClick={() => openBugReport()}>Report a bug</button>
          </div>
          {error && <p className="cs-land-micro">{error}</p>}
          {!bugs && !error && <p className="cs-help">Loading…</p>}
          {bugs && bugs.length === 0 && <p className="cs-help">Nothing reported yet. <Link to="/support">Need help instead?</Link></p>}
          <ul className="cs-support-list">
            {(bugs || []).map((b) => (
              <li key={b.id} className="cs-support-row bug-row">
                <div className="bug-row-top">
                  <strong>{b.title || 'Bug report'}</strong>
                  <BugStatusChip status={b.status} />
                </div>
                {b.description && <p className="bug-row-desc">{b.description}</p>}
                <span className="cs-help">
                  {when(b.createdAt)}
                  {b.attachments?.length ? ` · ${b.attachments.length} file${b.attachments.length === 1 ? '' : 's'}` : ''}
                  {b.status === 'shipped' && b.shippedAt ? ` · fixed ${when(b.shippedAt)}` : ''}
                  {b.status === 'closed' && b.closedReason ? ` · ${b.closedReason}` : ''}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
